import { Automation } from '../types';

export const groupByQuestionId = (automations: Automation[]): Record<number, Automation[]> => {
  const transformedAutomations: Record<number, Automation[]> = {};

  automations.forEach((automation) => {
    const questionId = automation.trigger.question_id;

    if (questionId in transformedAutomations) {
      transformedAutomations[questionId].push(automation);
    } else {
      transformedAutomations[questionId] = [automation];
    }
  });

  return transformedAutomations;
};
